export const crmOpportunityWorkbenchQueryRootKey = ["crm-opportunity-workbench"] as const;

export const crmOpportunityWorkbenchDefaultListParams = {
  page: 1,
  pageSize: 20,
  sortField: "updated_at",
  sortDirection: "desc" as const,
};

/** 商机列表按钮使用的通用功能权限；行级能力继续由 access_policy 控制。 */
export const crmOpportunityWorkbenchButtonPermissions = {
  page: "crm.opportunity:access",
  createCustomization: "customization.project:create",
  findCustomization: "crm.opportunity:find_customization",
  splitOpportunity: "crm.opportunity:split",
  /** 合同交接详情页访问权限；创订单入口需与 manage 同时具备。 */
  orderHandoverAccess: "customization.order_handover:access",
  orderHandover: "customization.order_handover:manage",
} as const;

export const opportunitySelectionStatusLabels: Record<string, string> = {
  candidate: "候选",
  selected: "已采用",
  not_adopted: "未采纳",
};
